<template>
  <div>
    <div v-if="!$route.query.page || ($route.query.page && token)">
      <div>
        <HomeView @login="login" @register="register" />
      </div>
    </div>
    <div v-else>
      <Auth @login="login" @register="register" />
    </div>
    <!-- <b-modal
      v-model="showModal"
      hide-footer
      centered
      size="md"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      :title="$t('notice')"
    >
      <div v-html="$t('alertText')"></div>
      <div style="margin-top: 30px; display: flex; justify-content: center">
        <b-button variant="primary" @click="IAgree"> {{ $t("IAgree") }} </b-button>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import HomeView from "@/views/Home.vue";
import Auth from "./Auth/auth";
import { mapState } from "vuex";
export default {
  name: "Home",
  components: {
    HomeView,
    Auth,
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapState("auth", ["token"]),
  },
  methods: {
    // IAgree(){
    //   this.showModal = false
    //   localStorage.setItem("agreeNotice", true)
    // },
    login() {
      if (this.$route.query.page != "login") {
        this.$router.push({
          path: "/",
          query: {
            page: "login",
          },
        });
      }
    },

    register() {
      if (this.$route.query.page != "register") {
        this.$router.push({
          path: "/",
          query: {
            page: "register",
          },
        });
      }
    },
  },
  mounted() {
    // if(!localStorage.getItem("agreeNotice")){
    //   this.showModal = true
    // }
  },
};
</script>
